import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './loading.css';
import './loading-btn.css';
import './LoadingButton.css';

const LoadingButton = (props) => (
  <button
    id={props.id}
    className={props.classes ? props.classes + ' button' : 'button'}
    onClick={props.onClick}
    disabled={props.loading || props.disabled}
  >
    {props.loading ? <div className="ld ld-ring ld-spin" /> : props.children}
  </button>
);

export default LoadingButton;

LoadingButton.propTypes = {
  id: PropTypes.string,
  classes: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

LoadingButton.defaultProps = {
  loading: false,
  disabled: false,
};
